import * as React from "react";
import { CustomerTaxResidencyModel } from "../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { CountryCodeMap } from "../../../../../Shared/Entities/Maps/CountryCodeMap";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { TaxReferenceTypeMap } from "../../ClientRecord/Resource/RegulatoryCountryHelper";
import { prepareTypography } from "../../Common/Review/ReviewParser";
import { fieldDefaultValue, renderYesOrNo } from "../Resource/CustomerMergeHelper";

interface IRegulatoryProps {
    tData: Array<CustomerTaxResidencyModel>;
    othertData: Array<CustomerTaxResidencyModel>;
}

const regulatoryConfig = (tData: Array<CustomerTaxResidencyModel>) => {
    const result = [];
    tData?.forEach((e) => {
        result.push(
            {
                title: "Country name",
                data: fieldDefaultValue(CountryCodeMap.getString(e?.Country)),
            },
            {
                title: "Client nationality",
                data: fieldDefaultValue(renderYesOrNo(e?.IsNationality)),
            },
            {
                title: "Client tax resident",
                data: fieldDefaultValue(renderYesOrNo(e?.IsTaxResident)),
            },
            {
                title: "Primary tax resident",
                data: fieldDefaultValue(renderYesOrNo(e?.PrimaryTaxResidency)),
            },
            {
                title: "Primary citizenship",
                data: fieldDefaultValue(renderYesOrNo(e?.PrimaryCitizenship)),
            },
            {
                title: "National identifier",
                data: fieldDefaultValue(e?.NationalIdentifier),
            },
            {
                title: "Passport identification number",
                data: fieldDefaultValue(e?.PassportNumber),
            },
            {
                title: "Tax reference",
                data: fieldDefaultValue(e?.TaxReference),
            },
            {
                title: "Tax reference type",
                data: fieldDefaultValue(TaxReferenceTypeMap[e?.TaxReferenceType]),
            }
        );
    });
    return result;
};

export const Regulatory = (props: IRegulatoryProps) => {
    const _sortedTax = props?.tData?.sort((a, b) => {
        if (a?.Country?.toString() > b?.Country?.toString()) {
            return 1;
        }
        if (a?.Country?.toString() < b?.Country?.toString()) {
            return -1;
        }
        return 0;
    });

    if (_sortedTax?.length < props.othertData?.length) {
        // add empty item to keep the same size
        const sizeDifference = props.othertData.length - _sortedTax.length;
        for (let i = 0; i < sizeDifference; i++) {
            _sortedTax.push({
                Country: null,
                IsTaxResident: null,
                PrimaryCitizenship: null,
                PrimaryTaxResidency: null,
                NationalIdentifier: null,
                PassportNumber: null,
                TaxReferenceType: null,
                TaxReference: null,
                TaxResidencyForPensionRelief: null,
                TaxExempt: null,
                TaxExemptionReason: null,
                IsNationality: null,
            });
        }
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h3>
                        <u>Regulatory</u>
                    </h3>
                </div>
            </div>
            <Typography {...prepareTypography(regulatoryConfig(_sortedTax), 1, "common")} />
        </>
    );
};
